import { useState } from 'react'

import CardActionArea from '@mui/material/CardActionArea'
import Snackbar from '@mui/material/Snackbar'
import Typography from '@components/_mui/Typography'

import usePubNub from '@shared/hooks/src/usePubNub'
import { useMe } from '@shared/providers/src/MeProvider'
import { queryClient } from '@shared/providers/src/QueryClientProvider'
import { QK } from '@shared/utils'

import { useSOPsFilters } from '@pages/StandardOperatingProcess/SOPsList'

import { styles, Title } from '../Notifications.utils'

export default function SOPsUpdates() {
  const me = useMe()
  const [, updateFilters] = useSOPsFilters()
  const [open, setOpen] = useState(false)
  const [data, setData] = useState(undefined)

  const handleClose = () => setOpen(false)
  const handleClick = () => {
    handleClose()
    updateFilters({ sops: 'view', sopId: data.sop_id })
  }

  usePubNub(`${me.role}_sop`, ({ action, attributes }) => {
    if (action === 'sop_notification_created') {
      queryClient.invalidateQueries({ queryKey: QK.users.id(me.id).sopNotifications.lists })
      setData(attributes)
      setOpen(true)
    }
  })

  return (
    <Snackbar
      open={open}
      onClose={(event, reason) => {
        if (reason === 'escapeKeyDown') handleClose()
      }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <CardActionArea onClick={handleClick} sx={styles.container}>
        <Title label="SOP" onClose={handleClose} />
        <Typography>
          Please review the latest updates to{' '}
          <b>
            {data?.title} (v.&nbsp;{data?.version})
          </b>
        </Typography>
      </CardActionArea>
    </Snackbar>
  )
}
